// Axios文档: https://www.kancloud.cn/yunye/axios/234845

import axios from 'axios'
import { stringify } from 'qs'
import { Message, MessageBox, Loading } from 'element-ui'
import { getToken, getRoles } from '@/utils/auth'
// import router from '@/router'
import store from '@/store'
// import { loadavg } from 'os';

export const API_URL = 'https://jk.zhutui.cn/api.php'
const isDEV = process.env.NODE_ENV === 'development'



const service = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
})
let loading = null
/**
 * POST请求
 * @param {String} apiName 接口do=后面的参数，表示接口的名称
 * @param {Object} data 请求参数
 * @param {Boolean} clear 是否清除data中为空字符串的字段
 */
export function post(apiName, data={}, set={}) {
  let {
    // 自定义 配置
    clear=true,
    clearToken=false,
    // axios 配置
    config={},
  } = set

  const cfg = Object.assign({
    data: clear ? clearData(data) : data,
    params: { do: apiName },
    method: 'post',
    transformRequest: [(data) => {
      if(clearToken) {
        if(data.tsid) {
          delete data['tsid']
        }
        if(data.asid) {
          delete data['asid']
        }
      }


      const keys = Object.keys(data || {})

      const hasFile = keys.find((key) => {
        const value = (data || {})[key]
        return value instanceof File || value instanceof FileList
      })

      if (hasFile) {
        const form = new FormData()
        keys.forEach((key) => {
          form.append(key, data[key])
        })
        return form
      }

      return stringify(data)
    }],
  }, config)

  return service.request(cfg)
}

// 不需要传sid的接口名单
const REQUEST_WHITE_LIST = [
  'admin_login',
]
// 弹出Loading黑名单
const REQUEST_LOADING_BLACK_LIST = [
  'message_session_unread',
  'taoke_taobao_order_limit_date_set',
  'taoke_commission_set',
  'admin_cms_banner_recommend_order_set',
  'taoke_cms_banner_recommend_order_set',
  'admin_plugin_app_upload',
  'taoke_follow_wx_check',
]


// 请求拦截器
service.interceptors.request.use(
  (config) => {

    let apiName = config.params.do

    const isFormData = config.data instanceof FormData

    if (isFormData) {
      config.headers['Content-Type'] = 'multipart/form-data'
    }

    // 权限
    if (!REQUEST_WHITE_LIST.includes(apiName)) {
      let role = getRoles()[0]
      let sidkey
      // 优先使用cookie里的用户角色
      if (role) {
        sidkey = role == 'admin' ? 'asid' : role == 'taoke' ? 'tsid' : 'csid'
      }
      // 没有用户角色的情况下，接口名称以 admin_* 开头的都是管理员接口，否则都是淘客接口或共用接口
      else {
        sidkey = apiName.includes('admin') ? 'asid' : 'tsid'
      }

      if (isFormData) {
        config.data.append(sidkey, getToken())
      } else {
        config.data[sidkey] = getToken()
      }
    }

    // 弹出Loading
    if (!REQUEST_LOADING_BLACK_LIST.includes(apiName)) {
      loading = Loading.service({
        // background: 'transparent'
      });
    }

    return config
  }
)

// 返回8684不需要理的接口名单
const RESPONSE_WHITE_LIST = ['admin_logout', 'taoke_logout', 'message_session_unread']

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const { data } = response

    let apiName = response.config.params.do

    loading && loading.close();

    // 登录失效
    if (data.error_code == 8684 && !RESPONSE_WHITE_LIST.includes(apiName)) {
      store.dispatch('FedLogOut') // 删除cookie

      // 提示用户，重新登录
      MessageBox.confirm('登录已失效，请重新登录', '登录失效', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // store.dispatch('FedLogOut').then(() => {
        //   location.reload() // 为了重新实例化vue-router对象 避免bug
        // })
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })

      return Promise.reject({
        error_code: data.error_code,
        error_message: data.error_message,
      })
    }
    return response
  },
  (error) => {
    console.error(error);
    loading && loading.close();
    Message.error('服务器繁忙,请重试')
    return Promise.reject(error);
  }
)


// 清除请求参数中 值位空的字符串
function clearData(data) {
  data = { ...data };
  Object.keys(data).forEach((key) => {
    if (data[key] === '') {
      delete data[key]
    }
  })
  return data
}

export const LOCAL_JSON_URL = isDEV ? '/json' : '/promote/dist/json'
const localJsonService = axios.create({
  baseURL: LOCAL_JSON_URL,
})
export function getLocalJson(api) {
  return localJsonService.get(api)
}

export default service
